import { useEffect, useRef } from 'react';

export const useAnimation = (callback: FrameRequestCallback, { enabled = true }: { enabled?: boolean } = {}) => {
    const requestRef = useRef<number>();
    const callbackRef = useRef(callback);

    useEffect(() => {
        // don't trigger the effect every time the callback changes, we just care what its value is
        // at the time we register the next frame
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const cb: FrameRequestCallback = (timestamp) => {
            callbackRef.current(timestamp);
            requestRef.current = requestAnimationFrame(cb);
        };

        requestRef.current = requestAnimationFrame(cb);
        return () => {
            if (requestRef.current) cancelAnimationFrame(requestRef.current);
        };
    }, [enabled]);
};
